import React from 'react';

import styles from './style.scss';


const DashboardSingleBooksetEmpty = () => (
  <div className={styles.container}>
    <div className={styles.containerImage} />
    <div className={styles.content}>
      <div className={styles.text}>
        <div className={styles.title} />
        <div className={styles.count} />
      </div>
    </div>
  </div>
);

export default DashboardSingleBooksetEmpty;
